import { DqCard } from "@decentriq/components";
import { Box, Stack, Typography } from "@mui/joy";
import capitalize from "lodash/capitalize";
import { Fragment, memo } from "react";
import { type AudienceRulesTree } from "features/mediaDataRoom/models";
import { CombinatorChip } from "./components";
import { mapAudienceConditionToPresentation } from "./config";

interface RuleBasedAudienceSummaryProps {
  audience: AudienceRulesTree;
}

const RuleBasedAudienceSummary = memo<RuleBasedAudienceSummaryProps>(
  ({ audience }) => {
    return (
      <Box width="100%">
        <Stack>
          <DqCard>
            <Typography
              level="body-sm"
              startDecorator={<b>Audience 1:</b>}
              textColor="inherit"
            >
              {audience.name}
            </Typography>
            {audience.filters?.filters.map((filter, index) => (
              <Stack
                key={`${filter.attribute}-${filter.condition}-${index}`}
                mt={1}
                spacing={0}
              >
                <Typography
                  level="body-sm"
                  startDecorator={<b>Attribute:</b>}
                  textColor="inherit"
                >
                  {capitalize(filter.attribute ?? "")}
                </Typography>
                <Typography
                  level="body-sm"
                  startDecorator={<b>Condition:</b>}
                  textColor="inherit"
                >
                  {(filter.condition &&
                    mapAudienceConditionToPresentation[filter.condition]) ??
                    filter.condition}
                </Typography>
                {filter.values?.length ? (
                  <Typography
                    level="body-sm"
                    startDecorator={<b>Value:</b>}
                    textColor="inherit"
                  >
                    {Array.isArray(filter.values)
                      ? filter.values.join(", ")
                      : filter.values}
                  </Typography>
                ) : null}
              </Stack>
            ))}
          </DqCard>
        </Stack>
        {audience.combine?.map((audience, index) => (
          <Stack gap={0} key={index}>
            <Fragment>
              {audience.operator && (
                <CombinatorChip operator={audience.operator} />
              )}
              <DqCard>
                <Typography
                  level="body-sm"
                  startDecorator={<b>Audience {index + 2}:</b>}
                  textColor="inherit"
                >
                  {audience.name}
                </Typography>
                {audience.filters?.filters.map((filter, index) => (
                  <Stack
                    key={`${filter.attribute}-${filter.condition}-${index}`}
                    mt={1}
                    spacing={0}
                  >
                    <Typography
                      level="body-sm"
                      startDecorator={<b>Attribute:</b>}
                      textColor="inherit"
                    >
                      {capitalize(filter.attribute ?? "")}
                    </Typography>
                    <Typography
                      level="body-sm"
                      startDecorator={<b>Condition:</b>}
                      textColor="inherit"
                    >
                      {(filter.condition &&
                        mapAudienceConditionToPresentation[filter.condition]) ??
                        filter.condition}
                    </Typography>
                    {filter.values?.length ? (
                      <Typography
                        level="body-sm"
                        startDecorator={<b>Value:</b>}
                        textColor="inherit"
                      >
                        {Array.isArray(filter.values)
                          ? filter.values.join(", ")
                          : filter.values}
                      </Typography>
                    ) : null}
                  </Stack>
                ))}
              </DqCard>
            </Fragment>
          </Stack>
        ))}
      </Box>
    );
  }
);
RuleBasedAudienceSummary.displayName = "RuleBasedAudienceSummary";

export default RuleBasedAudienceSummary;
